import cookies from 'js-cookie';

import { COOKIE_DOMAIN } from '../config';
import cookieNames from '../constants/cookieNames';
import storageKeys from '../constants/storageKeys';
import { removeItem } from './storage';

const removeLoginTokens = () => {
  removeItem(
    [window.localStorage, window.sessionStorage],
    storageKeys.loginTokens
  );

  [
    // NOTE: These below store user/session specific information
    cookieNames.accessToken,
    cookieNames.userQuote,
    cookieNames.store,
    cookieNames.phpSessionId,
    // NOTE: This was set for some behavior in TYPO3's Account.js
    cookieNames.sessionHash,
    cookieNames.loggedIn,
    // NOTE: These below are from old login flow.
    cookieNames.fs,
    cookieNames.frontend,
  ].forEach((cookieName) =>
    cookies.remove(cookieName, { domain: COOKIE_DOMAIN })
  );
};

export default removeLoginTokens;
